// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq-link[data-v-240e08e8]{display:inline-flex;align-items:center;opacity:.5;vertical-align:bottom}.object-char-item[data-v-240e08e8]{display:flex;grid-gap:20px;gap:20px;justify-content:space-between}.object-char-item[data-v-240e08e8]>:first-child{flex-grow:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
